export default __webpack_public_path__ + "static/media/Maintenance.77bb6494.svg";